import { AppReducer } from "@/features/applications";
import { IntReducer } from "@/features/internal";
import { BacktestReducer } from "@/features/backtest";
import { connectRouter } from "connected-react-router";
import { History } from "history";
import { combineReducers } from "redux";
import { RootState } from "./rootState";
import { firestoreReducer } from "redux-firestore";

export default (history: History) =>
  combineReducers<RootState>({
    app: AppReducer,
    int: IntReducer,
    backtest: BacktestReducer,
    router: connectRouter(history),
    // @ts-ignore
    firestore: firestoreReducer
  });
